const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/lead/list',
    authenticatedEntryPathAdminExpert: '/app/report/summary',
    authenticatedEntryPathStandard: '/app/lead/list',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig